import { enLeadScoringShell } from "./enLeadScoringShell";
import { enLeadScoringTitles } from "./enLeadScoringTitles";

export const enLeadScoring = {
	outputLanguage: "AI output language",
	pageTitle: "Lead Scoring",
	companyPersona: "Company / Persona",
	notApplicable: "Not applicable",
	active: "Active",
	inactive: "Inactive",
	noLeadScoringsConfigured: "No lead scorings configured",
	noCompanySegmentsConfigured: "No company segments configured",
	noPartnerSegmentsConfigured: "No partner segments configured",
	noInvestorsConfigured: "No investors configured.",
	noneAssigned: "None assigned",
	investor: "Investor",
	saveAndGoToCompany: "Save & Go to Company Segments",
	saveAndGoToLS: "Save & Go to Lead Scoring",
	saveAndGoToPersona: "Save & Go to Persona Segments",
	continueAndMapOnOverview: "Continue configuring company segments and then map on Overview",
	continueAndMapOnOverviewLS: "Continue configuring lead scorings and then map on Overview",
	continueAndMapOnOverviewPersona: "Continue configuring persona segments and then map on Overview",
	changeLogGeneralTitle: "Review manual changes regarding your Lead Scoring",
	changeLogTitle: "Review Change Log",
	changeLogDescription:
		" A full history of manual overrides made to lead scores. Use this to track corrections, spot patterns, and continuously improve your scoring criteria over time.",

	overviewTitle: "Assign lead scoring to your segments",
	overviewDescription:
		"For each combination of company segment and persona, select which lead scoring logic should be applied. This determines how leads are prioritized when they match that specific segment.",
	companySegment: "Company Segment",
	partnerSegment: "Partner Segment",
	leave: "Discard Changes & Leave",
	leaveTitle: "Unsaved Changes",
	leaveText: "You have unsaved changes. Are you sure you want to leave?",
	unsavedChanges: "You have unsaved changes",
	leadScoringsActive: "lead scorings active",
	noLeadScoringsActive: "No lead scorings active",
	saveAndTestLeadScoring: "Save and Test Lead Scoring logic",
	deleteConfirmPersona: "Are you sure you want to delete this persona?",
	deletePersonaTitle: "Delete Persona",
	companySegments: "Company Segments",
	personaSegments: "Persona Segments",
	employees: "Employees",
	hqCountry: "HQ Country",
	categorizedAs: "Categorized as",
	anotherCategorySuggestion: "We suggest to add another Category",
	applyNewSubCategory: "Apply new Sub-Category",
	reasoning: "Reasoning",
	defineCompany: "Refine Company Segment Description",
	ignore: "Ignore criterion",
	disqualify: "Disqualify lead",
	...enLeadScoringTitles,
	...enLeadScoringShell,
	title: "Lead Scoring",
	create: {
		title: "Create Lead Scoring",
	},
	addAnotherAICriterion: "Add another AI-based criterion",
	basedIn: "Based in",
	companyPrio: "Company Prio",
	personaPrio: "Persona Prio",
	leadScore: "Lead Score",
	isCategorizedAs: "is categorized as",
	editedByHuman: "Edited by a human",
	lastModified: "(Last modified {{time}} by {{firstName}} {{lastName}})",
	draftByAI: "Draft by AI",
	draft: "Draft",
	companyScoring: "Company Scoring",
	scoringDescription:
		"Refine the scoring based on quantitative data like company HQ or employee size as well as qualitative data that can be researched by an AI agent.",

	partnerSegments: "Partner Segments",
	investors: "Investors",
	investorsPleaseSelect:
		"Please select the types of investors that should be qualified (either as investor targets or potential partners / multipliers).",
	investorDescription:
		"The company is an Angel investor, Venture Capital firms, Private Equity Fund or Family office.",
	investorsInformation:
		"You can simply toggle on an turn off whether potential partners should be categorized and scored or not and select which types of investors are relevant for you. If you are selling to or partnering with Investors you can either create a sub-category or keep the main Investor category toggled on",
	partnersInformation:
		"You can simply toggle on an turn off whether potential partners should be categorized and scored or not",
	addAnotherSubCategory: "Add another Segment",
	draftToggle: "Draft - Toggle to activate",
	draftActive: "Active",

	draftToggleCompany: "Company Segmentation is not active - Toggle to activate",
	draftTogglePersona: "Persona Segmentation is not active - Toggle to activate",
	draftActiveCompany: "Company Segmentation is active",
	draftActivePersona: "Persona Segmentation is active",
	descriptionLabel: "Description (30-100 words)",
	personaScoring: "Persona Scoring",
	criterion: "Criterion",
	ifNotFound: "If not found",
	disqualified: "Disqualified",
	seniority: "Seniority",
	jobLevel: "Job Level",
	applyTheAboveLeadScoringToTheFollowing:
		"Apply the above lead scoring to the following company categories and personas",
	personLocation: "Person location",
	applyTheAboveLeadScoringToTheFollowingInfo:
		"You can apply this scoring to all personas at all companies or only one persona at one company. However, for all combinations of companies and personas a lead scoring needs to be applied",
	copyFromCompanyHQ: "Copy from Company HQ Location",
	point: "Point",
	points: "Points",
	companyHQ: "Company HQ Location",
	hqLocation: "HQ Location",
	industries: "Industries",
	employeeSize: "Employee Size",
	editName: "Edit name",
	companyCategory: "Company Category",
	existingPersonas: "Existing Personas",
	prospect: "Prospect",
	addAnotherLeadScoringLogic: "Add another Lead Scoring logic",
	areYouSureYouWantToDeleteCriteria: "Are you sure you want to delete this criteria?",
	selectAll: "Select all",
	deselectAll: "Deselect all",
	personaNotLinkedToAnySegment: "Some persona segments are not connected to any segments",

	anyCompanyLocation: "Any Company Location",
	youCanOnlyDeactivateIf: "You can only edit this Lead Scoring if it is deactivated",
	missingCompanySegment: "Some company segments are not in use by any lead scorings",
	missingPartnerSegment: "Some partner company segments are not in use by any lead scorings",
	missingPersonaSegment: "Some persona segments are not in use by any lead scorings",
	personaNotLinkedToProspects: "Some persona segments are not linked to any company segments",
	personaNotLinkedToPartners: "Some persona segments are not linked to any partner segments",
	companyNotLinkedToPersona: "Some company segments are not linked to any persona segments",
	partnerNotLinkedToPersona: "Some partner company segments are not linked to any persona segments",
	subCategory: "Segment",
	about: "About",
	save: "Save",
	saveError: "Failed to save assignments. Please try again.",
	saveScoringsError: "Failed to save the Lead Scoring grades. Please try again.",
	deleteCompanyTitle: "Delete Segment",
	deleteConfirm: "Are you sure you want to delete this segment?",
	prevCompanies: "Previous 5 companies",
	nextCompanies: "Next 5 companies",
	mightTakeAMinute: "This might take a minute...",
	nextCompanyTestBtn: "Next: Define Personas",
	saveAndTest: "Save and Test Company Segments",
	saveAndContinue: "Save and Continue",
	researchAgent: "AI Research Agent",
	scoreIsUpdating: "Score is updating...",
	name: "Name",
	companyWasNotCategorized: "Company was not categorized",
	researchAgentInfo:
		"You can write in natural language which types of companies should be disqualified",
	testCompanyText:
		"We will pull a random selection of companies to test your descriptions against. This will take 1-2 minutes",
	disqualifyAllCompaniesPurely: "Disqualify all companies that purely sell to consumers",
	disqualifyCompanies: "Disqualify companies with the following criteria",
	disqualifyCompaniesWithCriteria:
		"Please define criteria that should disqualify companies. For example, if you target startups and corporates, but both of them should only be based in the US, you should not disqualify by number of employees, but company headquarter.",
	descripbeCompanyLabel: "Describe the Service or Product of your company (30-100 words",
	subCategoryInfo:
		"You can give this any name. This does NOT influence the company categorization and lead scoring",
	companySegmentDescription:
		"Refine descriptions of potential company segments, partner segments and investors. For company and partner segments you can create up to 5 sub-categories that can also be scored differently. You can also define criteria that should disqualify companies directly. This will help	you to potentially save credits for workflows like Open Jobs or XLS enrichments and speed up the list building process.",
	generalDescription: "General Description (30-100 words)",
	configureLeadScoringPreferences: "Configure your Lead Scoring Preferences",
	personaSegmentDescription:
		"Refine descriptions of potential personas and groups of job titles that you target at company segments, partner segments and/or investors. You can create as many personas as you like, but we recommend 2-8 different personas. You can also define for which types of companies which personas should be identified.",
	personaSegmentTitle: "Refine Persona Segment Description",
	functionalDescription: "Functional Description of the Department or Persona (30-100 words)",
	functionalDescriptionInfo:
		"This description influences how Signalist categorizes any person. Please ONLY describe their responsibility and use Job titles to include/exclude to fine-tune the description. Please adjust and test your descriptions to get the best possible results",
	personaOrDepartment: "Persona or Department",
	personaOrDepartmentInfo:
		"You can give this any name. This does NOT influence the persona categorization and lead scoring",
	jobTitlesToInclude: "Example job titles to include",
	jobTitlesIncludeInfo:
		"You don’t need to include all job titles. However, the more distinct titles you add, the easier it is for the AI to categorize correctly.",
	jobTitlesToExclude: "Example job titles to exclude",
	linkedToProspects: "Linked to the following Company Segments",
	linkedToPartners: "Linked to the following Partner Segments",
	linkedToInvestors: "Linked to Investors",
	addAnotherPersonaDepartment: "Add another Persona or Department",
	linkedToProspectsInfo: "This persona may exist in the following company segments.",
	disqualifyAllPeople: "Disqualify all people with the following criteria",
	disqualifyAllPeopleWithCriteria:
		"Please define criteria that should disqualify people. For example, if you target C-Level executives or directors and you only target people in the US, you should disqualify all that do not have these seniority level and are not located in the United States.",
	testPersonas:
		"We will pull a random selection of personas to test your descriptions against. This will take 1-2 minutes",
	saveAndTestPersona: "Save and Test Persona Segments",
	nextPersona: "Next: Define Scoring",
	prevProspects: "Previous 5 prospects",
	nextProspects: "Next 5 prospects",
	greenText: "You have all Lead Scoring criteria set up and active",
	yellowText: "You have some Lead Scoring criteria that are not active",
	redText: "You have some inactive Lead Scorings",
	noPersonaTest:
		"No categorized companies available. To test your persona categories, you first need to make sure that you have successfully categorized at least one company. Please either reenter the test of company criteria tests and click on &quot;Next 5 companies&quot;, if on your first page are only &quot;Disqualified&quot; results or alter your segments for your company categories.",
	prospectsValue:
		"Our target audience consists of mid-level to senior professionals in small to mid-sized knowledge-based organizations, typically with 50–200 employees. These individuals lead cross-functional teams or innovation projects and face the challenge of aligning diverse perspectives under time pressure. They are pragmatic, open to external input, and value structured collaboration. Most are in sectors like professional services, tech, education, or non-profits. They seek practical ways to boost clarity, ownership, and momentum without lengthy interventions. While experienced, they often lack internal facilitation expertise. ",
	potentialPartner:
		"The company is a potential partner for www.signalist.io and can help sell the solution to their clients, either by improving their product or service or by upselling or cross-selling www.signalist.io to their clients. Notable examples are Sales Agencies, Content/PR Agencies, Content Creation Software or Event Organizers.",
	togglingOffPartners: "Deactivate",
	toggleOffPartners: "Are you sure?",
	togglePartnersText:
		"Deactivating partner segments will remove them from persona segments and lead scoring.",
};
